


/**
* @module SDKModule
* @author Jonathan Casarrubias <t:@johncasarrubias> <gh:jonathan-casarrubias>
* @license MIT 2016 Jonathan Casarrubias
* @version 2.1.0
* @description
* The SDKModule is a generated Software Development Kit automatically built by
* the LoopBack SDK Builder open source module.
*
* The SDKModule provides Angular 2 >= RC.5 support, which means that NgModules
* can import this Software Development Kit as follows:
*
*
* APP Route Module Context
* ============================================================================
* import { NgModule }       from '@angular/core';
* import { BrowserModule }  from '@angular/platform-browser';
* // App Root
* import { AppComponent }   from './app.component';
* // Feature Modules
* import { SDK[Browser|Node|Native]Module } from './shared/sdk/sdk.module';
* // Import Routing
* import { routing }        from './app.routing';
* @NgModule({
*  imports: [
*    BrowserModule,
*    routing,
*    SDK[Browser|Node|Native]Module.forRoot()
*  ],
*  declarations: [ AppComponent ],
*  bootstrap:    [ AppComponent ]
* })
* export class AppModule { }
*
**/
import { JSONSearchParams } from './services/core/search.params';
import { ErrorHandler } from './services/core/error.service';
import { LoopBackAuth } from './services/core/auth.service';
import { LoggerService } from './services/custom/logger.service';
import { SDKModels } from './services/custom/SDKModels';
import { InternalStorage, SDKStorage } from './storage/storage.swaps';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CookieBrowser } from './storage/cookie.browser';
import { StorageBrowser } from './storage/storage.browser';
import { SocketBrowser } from './sockets/socket.browser';
import { SocketDriver } from './sockets/socket.driver';
import { SocketConnection } from './sockets/socket.connections';
import { RealTime } from './services/core/real.time';
import { EmailApi } from './services/custom/Email';
import { FileStorageApi } from './services/custom/FileStorage';
import { StorageApi } from './services/custom/Storage';
import { StorageAttendanceApi } from './services/custom/StorageAttendance';
import { StorageAttendanceLocalApi } from './services/custom/StorageAttendanceLocal';
import { StorageChatApi } from './services/custom/StorageChat';
import { StorageClaimApi } from './services/custom/StorageClaim';
import { StorageCompanyProfileApi } from './services/custom/StorageCompanyProfile';
import { StorageProfileApi } from './services/custom/StorageProfile';
import { StoragePostApi } from './services/custom/StoragePost';
import { StsmartnoticecommentsApi } from './services/custom/Stsmartnoticecomments';
import { StsmartnoticememberApi } from './services/custom/Stsmartnoticemember';
import { RegisterApi } from './services/custom/Register';
import { RegisterOnboardingApi } from './services/custom/RegisterOnboarding';
import { SFAttendanceApi } from './services/custom/SFAttendance';
import { SFLeaveRequestApi } from './services/custom/SFLeaveRequest';
import { SFOvertimeRequestApi } from './services/custom/SFOvertimeRequest';
import { SunfishApi } from './services/custom/Sunfish';
import { TclmuserApi } from './services/custom/Tclmuser';
import { TcltrequestApi } from './services/custom/Tcltrequest';
import { TeodempaddressApi } from './services/custom/Teodempaddress';
import { TeodempcompanyApi } from './services/custom/Teodempcompany';
import { TeodemppersonalApi } from './services/custom/Teodemppersonal';
import { TeodempsurveyApi } from './services/custom/Teodempsurvey';
import { TeodempsurveydetailApi } from './services/custom/Teodempsurveydetail';
import { TeodsurveyquestApi } from './services/custom/Teodsurveyquest';
import { TeodsurveyquestoptApi } from './services/custom/Teodsurveyquestopt';
import { TeomcompanyApi } from './services/custom/Teomcompany';
import { TeomemppersonalApi } from './services/custom/Teomemppersonal';
import { TeompositionApi } from './services/custom/Teomposition';
import { TeomsurveyheaderApi } from './services/custom/Teomsurveyheader';
import { TtadattendanceApi } from './services/custom/Ttadattendance';
import { TtadattstatusdetailApi } from './services/custom/Ttadattstatusdetail';
import { TtadempgetleaveApi } from './services/custom/Ttadempgetleave';
import { TtadleaverequestApi } from './services/custom/Ttadleaverequest';
import { TtadleaverequestdetailApi } from './services/custom/Ttadleaverequestdetail';
import { TtadovtrequestApi } from './services/custom/Ttadovtrequest';
import { TtadovtrequestdetailApi } from './services/custom/Ttadovtrequestdetail';
import { TtamleavetypeApi } from './services/custom/Ttamleavetype';
import { TtamshiftdailyApi } from './services/custom/Ttamshiftdaily';
import { ViewemployeeApi } from './services/custom/Viewemployee';
import { ViewGoEmpApi } from './services/custom/ViewGoEmp';
import { ViewSearchEmpApi } from './services/custom/ViewSearchEmp';
import { AccessmanagementApi } from './services/custom/Accessmanagement';
import { ViewAttReportApi } from './services/custom/ViewAttReport';
import { TtadattcorrectionApi } from './services/custom/Ttadattcorrection';
import { SFAttCorrectionRequestApi } from './services/custom/SFAttCorrectionRequest';
import { ViewLeaveReportApi } from './services/custom/ViewLeaveReport';
import { ViewOvertimeReportApi } from './services/custom/ViewOvertimeReport';
import { ViewShiftscheduleReportApi } from './services/custom/ViewShiftscheduleReport';
import { ViewCareerReportApi } from './services/custom/ViewCareerReport';
import { ViewEmpReqApi } from './services/custom/ViewEmpReq';
import { ViewLeaveBalanceReportApi } from './services/custom/ViewLeaveBalanceReport';
import { ViewHeadcountGenderApi } from './services/custom/ViewHeadcountGender';
import { ViewHeadcountMaritalApi } from './services/custom/ViewHeadcountMarital';
import { ViewHeadcountPosApi } from './services/custom/ViewHeadcountPos';
import { SFGenerateLeaveBalanceApi } from './services/custom/SFGenerateLeaveBalance';
import { TsaimembersettingApi } from './services/custom/Tsaimembersetting';
import { SFAttendanceStatusApi } from './services/custom/SFAttendanceStatus';
import { TtamondutyallowitemApi } from './services/custom/Ttamondutyallowitem';
import { TrmmreimtypeApi } from './services/custom/Trmmreimtype';
import { TtamondutypurposetypeApi } from './services/custom/Ttamondutypurposetype';
import { TtadondutyrequestApi } from './services/custom/Ttadondutyrequest';
import { TtadondutyrequestdtlApi } from './services/custom/Ttadondutyrequestdtl';
import { TtadondutyrequestdtlAtdApi } from './services/custom/TtadondutyrequestdtlAtd';
import { TtadondutyrequestdtlItemApi } from './services/custom/TtadondutyrequestdtlItem';
import { TtarondutypurposecompApi } from './services/custom/Ttarondutypurposecomp';
import { SFOnDutyApi } from './services/custom/SFOnDuty';
import { ViewOndutyPurposeItemApi } from './services/custom/ViewOndutyPurposeItem';
import { TtamoddestinationApi } from './services/custom/Ttamoddestination';
import { SFClaimRequestApi } from './services/custom/SFClaimRequest';
import { SFBusinesstripSettingApi } from './services/custom/SFBusinesstripSetting';
import { SfBusinesstripdeclarationApi } from './services/custom/SfBusinesstripdeclaration';
import { TtadondutydeclarationApi } from './services/custom/Ttadondutydeclaration';
import { TtadondutydeclarationdtlApi } from './services/custom/Ttadondutydeclarationdtl';
import { SFLeaveRequestSF6Api } from './services/custom/SFLeaveRequestSF6';
import { SFRequestInboxApi } from './services/custom/SFRequestInbox';
import { SFOvertimeRequestSF6Api } from './services/custom/SFOvertimeRequestSF6';
import { TspostserviceApi } from './services/custom/Tspostservice';
import { TschatserviceApi } from './services/custom/Tschatservice';
import { TsfeedserviceApi } from './services/custom/Tsfeedservice';
import { TscalendarserviceApi } from './services/custom/Tscalendarservice';
import { TsmarketplaceApi } from './services/custom/Tsmarketplace';
import { TschatrealtimeApi } from './services/custom/Tschatrealtime';
import { SfrequestforApi } from './services/custom/Sfrequestfor';
import { SFAttUploadSF6Api } from './services/custom/SFAttUploadSF6';
import { TtadattendancetempApi } from './services/custom/Ttadattendancetemp';
import { Sfbusinesstripdeclarationsf6Api } from './services/custom/Sfbusinesstripdeclarationsf6';
import { SFAttCorrectionRequestSf6Api } from './services/custom/SFAttCorrectionRequestSf6';
import { SFAttendanceSF6Api } from './services/custom/SFAttendanceSF6';
import { SFPolicyApi } from './services/custom/SFPolicy';
import { SFShiftScheduleSF6Api } from './services/custom/SFShiftScheduleSF6';
import { SFAnnouncementApi } from './services/custom/SFAnnouncement';
import { SecurestorageApi } from './services/custom/Securestorage';
import { ERPsalesCustomerApi } from './services/custom/ERPsalesCustomer';
import { SFShiftScheduleApi } from './services/custom/SFShiftSchedule';
import { SFSearchApi } from './services/custom/SFSearch';
import { SFAttendanceListApi } from './services/custom/SFAttendanceList';
import { WorkflowApi } from './services/custom/Workflow';
import { SFShiftDailyApi } from './services/custom/SFShiftDaily';
import { SfRequestApi } from './services/custom/SfRequest';
import { SfPayslipApi } from './services/custom/SfPayslip';
import { SFClaimReportApi } from './services/custom/SFClaimReport';
import { SfPayrollWizardApi } from './services/custom/SfPayrollWizard';
import { SFBankTransferReportApi } from './services/custom/SFBankTransferReport';
import { SFBPJSKSReportApi } from './services/custom/SFBPJSKSReport';
import { SFPayProcessApi } from './services/custom/SFPayProcess';
import { SFBPJSTKReportApi } from './services/custom/SFBPJSTKReport';
import { SFPayPeriodApi } from './services/custom/SFPayPeriod';
import { SFBpjsTkSummaryReportApi } from './services/custom/SFBpjsTkSummaryReport';
import { SFEmployeePayrollDataApi } from './services/custom/SFEmployeePayrollData';
import { Sfspt1721iApi } from './services/custom/Sfspt1721i';
import { SFSptMasaApi } from './services/custom/SFSptMasa';
import { StoragePayrollApi } from './services/custom/StoragePayroll';
import { SFPayrollApi } from './services/custom/SFPayroll';
import { SFPayProcessReportApi } from './services/custom/SFPayProcessReport';
import { SFUploadPayComponentApi } from './services/custom/SFUploadPayComponent';
import { SfCareerApi } from './services/custom/SfCareer';
import { SFChangeSpvApi } from './services/custom/SFChangeSpv';
import { SFAttSummaryApi } from './services/custom/SFAttSummary';
import { TtamattstatusApi } from './services/custom/Ttamattstatus';
import { SFShiftDailySF6Api } from './services/custom/SFShiftDailySF6';
import { SFProfileApi } from './services/custom/SFProfile';
import { SFCompanyApi } from './services/custom/SFCompany';
import { SFChangePrivacyApi } from './services/custom/SFChangePrivacy';
import { RegistrationNewApi } from './services/custom/RegistrationNew';
import { SFUploadPayHistoryApi } from './services/custom/SFUploadPayHistory';
import { BuilderServiceApi } from './services/custom/BuilderService';
import { InvitationMemberApi } from './services/custom/InvitationMember';
import { SFEBankingApi } from './services/custom/SFEBanking';
import { ERPfinanceApi } from './services/custom/ERPfinance';
import { ERPpurchaseApi } from './services/custom/ERPpurchase';
import { ERPinventoryApi } from './services/custom/ERPinventory';
import { StorageInvitationApi } from './services/custom/StorageInvitation';
import { MarketplaceAccessApi } from './services/custom/MarketplaceAccess';
import { SFSpt1721A1Api } from './services/custom/SFSpt1721A1';
import { TaskFeedbackServiceApi } from './services/custom/TaskFeedbackService';
import { SFBusinesstripReportApi } from './services/custom/SFBusinesstripReport';
import { SFOnDutySF6Api } from './services/custom/SFOnDutySF6';
import { SFOvtCancelRequestSF6Api } from './services/custom/SFOvtCancelRequestSF6';
import { SFOvtCancelRequestApi } from './services/custom/SFOvtCancelRequest';
import { SFLeaveCancelRequestApi } from './services/custom/SFLeaveCancelRequest';
import { SFLeaveCancelRequestSF6Api } from './services/custom/SFLeaveCancelRequestSF6';
import { ERPaccountingApi } from './services/custom/ERPaccounting';
import { ERPreportApi } from './services/custom/ERPreport';
import { ERPdataAuthApi } from './services/custom/ERPdataAuth';
import { ERPsalesContractApi } from './services/custom/ERPsalesContract';
import { ERPutilApi } from './services/custom/ERPutil';
import { ERPsalesOrderApi } from './services/custom/ERPsalesOrder';
import { PostServiceApi } from './services/custom/PostService';
import { CalendarServiceApi } from './services/custom/CalendarService';
import { FeedServiceApi } from './services/custom/FeedService';
import { ERPproductionApi } from './services/custom/ERPproduction';
import { ERPfixedAssetApi } from './services/custom/ERPfixedAsset';
import { SFElearningSF6Api } from './services/custom/SFElearningSF6';
import { SFElearningReportApi } from './services/custom/SFElearningReport';
import { SettingServiceApi } from './services/custom/SettingService';
import { ERPproformaInvoiceApi } from './services/custom/ERPproformaInvoice';
import { ERPsalesBadDebtApi } from './services/custom/ERPsalesBadDebt';
import { ERPsalesPlaningApi } from './services/custom/ERPsalesPlaning';
import { ERPsalesPrepaymentInvoiceApi } from './services/custom/ERPsalesPrepaymentInvoice';
import { ERPsalesReturnApi } from './services/custom/ERPsalesReturn';
import { ERPshippingInstructionApi } from './services/custom/ERPshippingInstruction';
import { ERPsalesPrepaymentSettlementApi } from './services/custom/ERPsalesPrepaymentSettlement';
import { ERPsalesDCNoteApi } from './services/custom/ERPsalesDCNote';
import { ERPprojectApi } from './services/custom/ERPproject';
import { SFPollingApi } from './services/custom/SFPolling';
import { SfgisServiceApi } from './services/custom/SfgisService';
import { SFSmartfeedApi } from './services/custom/SFSmartfeed';
import { ERPpurchasePrepaymentInvoiceApi } from './services/custom/ERPpurchasePrepaymentInvoice';
import { ERPpurchaseContractApi } from './services/custom/ERPpurchaseContract';
import { ERPpurchaseDCNoteApi } from './services/custom/ERPpurchaseDCNote';
import { ERPpurchasePrepaymentSettlementApi } from './services/custom/ERPpurchasePrepaymentSettlement';
import { ERPpurchaseReturnApi } from './services/custom/ERPpurchaseReturn';
import { ERPpurchaseCostingSheetApi } from './services/custom/ERPpurchaseCostingSheet';
import { ERPpurchaseReturnRequisitionApi } from './services/custom/ERPpurchaseReturnRequisition';
import { ERPinternalInventoryRequisitionApi } from './services/custom/ERPinternalInventoryRequisition';
import { ERPinternalInventoryRequisitionReturnApi } from './services/custom/ERPinternalInventoryRequisitionReturn';
import { ERPinventoryAdjustmentValueApi } from './services/custom/ERPinventoryAdjustmentValue';
import { ERPinventoryAdjustmentApi } from './services/custom/ERPinventoryAdjustment';
import { ERPitemConversionApi } from './services/custom/ERPitemConversion';
import { ERPtransferOrderApi } from './services/custom/ERPtransferOrder';
import { SFAttValidationApi } from './services/custom/SFAttValidation';
import { ERPpurchaseRequestApi } from './services';
import { ActivityApi } from './services/custom/Activity';
import { StorageActivityApi } from './services/custom/StorageActivity';
import { ActivityImagesApi } from './services/custom/ActivityImages';
import { ActivityServiceApi } from './services/custom/ActivityService';
import { StorageLeaveApi } from './services/custom/StorageLeave';
import { LeaveSetupApi } from './services/custom/LeaveSetup';
import { AttendanceMachineApi } from './services/custom/AttendanceMachine';
import { StorageAttendanceMachineApi } from './services/custom/StorageAttendanceMachine';
import { LeaderBoardApi } from './services/custom/LeaderBoard';
import { SFAppraisalApi } from './services/custom/SFAppraisal';
import { PositionApi } from './services/custom/Position';
import { StandardizedServiceApi } from './services/custom/StandardizedService';
import { WorkLocationApi } from './services/custom/WorkLocation';
import { DepartmentApi } from './services/custom/Department';
import { CostCenterServiceApi } from './services/custom/CostCenterService';
import { QueueServiceApi } from './services/custom/QueueService';
import { JobGradeServicesApi } from './services/custom/JobGradeServices';
import { WinnerHistoryApi } from './services/custom/WinnerHistory';
import { StoragePartnerApi } from './services/custom/StoragePartner';
import { StorageAttachmentFileApi } from './services/custom/StorageAttachmentFile';
import { ViewEmpOvtReportApi } from './services/custom/ViewEmpOvtReport';
import { SsobranchserviceApi } from './services/custom/Ssobranchservice';
import { LeaveReportServiceApi } from './services/custom/LeaveReportService';
import { ImplementationServiceApi } from './services/custom/ImplementationService';
import { SuspectAttendanceApi } from './services/custom/SuspectAttendance';
import { TtamattlocationServiceApi } from './services/custom/TtamattlocationService';
import { TtademplocationServiceApi } from './services/custom/TtademplocationService';
import { TeomworklocationServiceApi } from './services/custom/TeomworklocationService';
import { ViewActivityReportApi } from './services/custom/ViewActivityReport';
import { EmployeeDataUpdateApi } from './services/custom/EmployeeDataUpdate';
import { SFMassLeaveApi } from './services/custom/SFMassLeave';
import { SFClaimCancelRequestApi } from './services/custom/SFClaimCancelRequest';
import { PaymentServiceApi } from './services/custom/PaymentService';
import { PayrollHistoryServiceApi } from './services/custom/PayrollHistoryService';
import { EmployeeServiceApi } from './services/custom/EmployeeService';
import { SubscriptionServiceApi } from './services/custom/SubscriptionService';
import { MakeIdCardApi } from './services/custom/MakeIdCard';
import { StorageIdCardApi } from './services/custom/StorageIdCard';
import { PersonalApi } from './services/custom/Personal';
import { AddressApi } from './services/custom/Address';
import { LookupApi } from './services/custom/Lookup';
import { EmergencyApi } from './services/custom/Emergency';
import { FamilydependentApi } from './services/custom/Familydependent';
import { EducationApi } from './services/custom/Education';
import { JobexpApi } from './services/custom/Jobexp';
import { MedicalApi } from './services/custom/Medical';
import { ContactApi } from './services/custom/Contact';
import { EmployeeCareerApi } from './services/custom/EmployeeCareer';
import { SunfishAuthenticatorServiceApi } from './services/custom/SunfishAuthenticatorService';
import {PersonalEmployeeReportApi} from "./services/custom/PersonalEmployeeReport";
import { AttendanceReportApi } from './services/custom/AttendanceReport';
import { PaydayLoanServiceApi } from './services/custom/PaydayLoanService';
import { BankAccountApi } from './services/custom/BankAccount';
import { InsuranceDataApi } from './services/custom/InsuranceData';
import { GovernmentTaxApi } from './services/custom/GovernmentTax';
import { SFApprovalSettingApi } from './services/custom/SFApprovalSetting';
import { ListSpvPathApi } from './services/custom/ListSpvPath';
import { TgospfaceencodingApi } from './services/custom/Tgospfaceencoding';
import { EmployeeRequestApi } from "./services/custom/EmployeeRequest";
import { UsersRatingApi } from "./services/custom/UsersRating";
import { SurveyServiceApi } from './services/custom/SurveyService';
import { SFLoanRequestApi } from './services/custom/SFLoanRequest';
import { SFLoanRequestSF6Api } from './services/custom/SFLoanRequestSF6';
import { YesdokserviceApi } from './services/custom/Yesdokservice';
/**
* @module SDKBrowserModule
* @description
* This module should be imported when building a Web Application in the following scenarios:
*
*  1.- Regular web application
*  2.- Angular universal application (Browser Portion)
*  3.- Progressive applications (Angular Mobile, Ionic, WebViews, etc)
**/
@NgModule({
  imports: [CommonModule, HttpModule],
  declarations: [],
  exports: [],
  providers: [
    ErrorHandler,
    SocketConnection
  ]
})
export class SDKBrowserModule {
  static forRoot(internalStorageProvider: any = {
    provide: InternalStorage,
    useClass: CookieBrowser
  }): ModuleWithProviders {
    return {
      ngModule: SDKBrowserModule,
      providers: [
        LoopBackAuth,
        LoggerService,
        JSONSearchParams,
        SDKModels,
        RealTime,
        EmailApi,
        FileStorageApi,
        StorageApi,
        StorageAttendanceApi,
        StorageAttendanceLocalApi,
        StorageChatApi,
        StorageClaimApi,
        StorageCompanyProfileApi,
        StorageProfileApi,
        StoragePostApi,
        StsmartnoticecommentsApi,
        StsmartnoticememberApi,
        RegisterApi,
        RegisterOnboardingApi,
        SFAttendanceApi,
        SFLeaveRequestApi,
        SFOvertimeRequestApi,
        SunfishApi,
        TclmuserApi,
        TcltrequestApi,
        TeodempaddressApi,
        TeodempcompanyApi,
        TeodemppersonalApi,
        TeodempsurveyApi,
        TeodempsurveydetailApi,
        TeodsurveyquestApi,
        TeodsurveyquestoptApi,
        TeomcompanyApi,
        TeomemppersonalApi,
        TeompositionApi,
        TeomsurveyheaderApi,
        TtadattendanceApi,
        TtadattstatusdetailApi,
        TtadempgetleaveApi,
        TtadleaverequestApi,
        TtadleaverequestdetailApi,
        TtadovtrequestApi,
        TtadovtrequestdetailApi,
        TtamleavetypeApi,
        TtamshiftdailyApi,
        ViewemployeeApi,
        ViewGoEmpApi,
        ViewSearchEmpApi,
        AccessmanagementApi,
        ViewAttReportApi,
        TtadattcorrectionApi,
        SFAttCorrectionRequestApi,
        ViewLeaveReportApi,
        ViewOvertimeReportApi,
        ViewShiftscheduleReportApi,
        ViewCareerReportApi,
        ViewEmpReqApi,
        ViewLeaveBalanceReportApi,
        ViewHeadcountGenderApi,
        ViewHeadcountMaritalApi,
        ViewHeadcountPosApi,
        SFGenerateLeaveBalanceApi,
        TsaimembersettingApi,
        SFAttendanceStatusApi,
        TtamondutyallowitemApi,
        TrmmreimtypeApi,
        TtamondutypurposetypeApi,
        TtadondutyrequestApi,
        TtadondutyrequestdtlApi,
        TtadondutyrequestdtlAtdApi,
        TtadondutyrequestdtlItemApi,
        TtarondutypurposecompApi,
        SFOnDutyApi,
        ViewOndutyPurposeItemApi,
        TtamoddestinationApi,
        SFClaimRequestApi,
        SFBusinesstripSettingApi,
        SfBusinesstripdeclarationApi,
        TtadondutydeclarationApi,
        TtadondutydeclarationdtlApi,
        SFLeaveRequestSF6Api,
        SFRequestInboxApi,
        SFOvertimeRequestSF6Api,
        TspostserviceApi,
        TschatserviceApi,
        TsfeedserviceApi,
        TscalendarserviceApi,
        TsmarketplaceApi,
        TschatrealtimeApi,
        SfrequestforApi,
        SFAttUploadSF6Api,
        TtadattendancetempApi,
        Sfbusinesstripdeclarationsf6Api,
        SFAttCorrectionRequestSf6Api,
        SFAttendanceSF6Api,
        SFPolicyApi,
        SFShiftScheduleSF6Api,
        SFAnnouncementApi,
        SecurestorageApi,
        ERPsalesCustomerApi,
        SFShiftScheduleApi,
        SFSearchApi,
        SFAttendanceListApi,
        WorkflowApi,
        SFShiftDailyApi,
        SfRequestApi,
        SfPayslipApi,
        SFClaimReportApi,
        SfPayrollWizardApi,
        SFBankTransferReportApi,
        SFBPJSKSReportApi,
        SFPayProcessApi,
        SFBPJSTKReportApi,
        SFPayPeriodApi,
        SFBpjsTkSummaryReportApi,
        SFEmployeePayrollDataApi,
        Sfspt1721iApi,
        SFSptMasaApi,
        StoragePayrollApi,
        SFPayrollApi,
        SFPayProcessReportApi,
        SFUploadPayComponentApi,
        SfCareerApi,
        SFChangeSpvApi,
        SFAttSummaryApi,
        TtamattstatusApi,
        SFShiftDailySF6Api,
        SFProfileApi,
        SFCompanyApi,
        SFChangePrivacyApi,
        RegistrationNewApi,
        SFUploadPayHistoryApi,
        BuilderServiceApi,
        InvitationMemberApi,
        SFEBankingApi,
        ERPfinanceApi,
        ERPpurchaseApi,
        ERPinventoryApi,
        StorageInvitationApi,
        MarketplaceAccessApi,
        SFSpt1721A1Api,
        TaskFeedbackServiceApi,
        SFBusinesstripReportApi,
        SFOnDutySF6Api,
        SFOvtCancelRequestSF6Api,
        SFOvtCancelRequestApi,
        SFLeaveCancelRequestApi,
        SFLeaveCancelRequestSF6Api,
        ERPaccountingApi,
        ERPreportApi,
        ERPdataAuthApi,
        ERPsalesContractApi,
        ERPutilApi,
        ERPsalesOrderApi,
        PostServiceApi,
        CalendarServiceApi,
        FeedServiceApi,
        ERPproductionApi,
        ERPfixedAssetApi,
        SFElearningSF6Api,
        SFElearningReportApi,
        SettingServiceApi,
        ERPproformaInvoiceApi,
        ERPsalesBadDebtApi,
        ERPsalesPlaningApi,
        ERPsalesPrepaymentInvoiceApi,
        ERPsalesReturnApi,
        ERPshippingInstructionApi,
        ERPsalesPrepaymentSettlementApi,
        ERPsalesDCNoteApi,
        ERPprojectApi,
        SFPollingApi,
        SfgisServiceApi,
        SFSmartfeedApi,
        ERPpurchasePrepaymentInvoiceApi,
        ERPpurchaseContractApi,
        ERPpurchaseDCNoteApi,
        ERPpurchasePrepaymentSettlementApi,
        ERPpurchaseReturnApi,
        ERPpurchaseCostingSheetApi,
        ERPpurchaseReturnRequisitionApi,
        ERPinternalInventoryRequisitionApi,
        ERPinternalInventoryRequisitionReturnApi,
        ERPinventoryAdjustmentValueApi,
        ERPinventoryAdjustmentApi,
        ERPitemConversionApi,
        ERPtransferOrderApi,
        SFAttValidationApi,
        ERPpurchaseRequestApi,
        ActivityApi,
        StorageActivityApi,
        ActivityImagesApi,
        ActivityServiceApi,
        StorageLeaveApi,
        LeaveSetupApi,
        AttendanceMachineApi,
        StorageAttendanceMachineApi,
        LeaderBoardApi,
        CostCenterServiceApi,
        DepartmentApi,
        PositionApi,
        StandardizedServiceApi,
        WorkLocationApi,
        SFAppraisalApi,
        QueueServiceApi,
        JobGradeServicesApi,
        WinnerHistoryApi,
        StoragePartnerApi,
        StorageAttachmentFileApi,
        ViewEmpOvtReportApi,
        SsobranchserviceApi,
        LeaveReportServiceApi,
        ImplementationServiceApi,
        SuspectAttendanceApi,
        TtamattlocationServiceApi,
        TtademplocationServiceApi,
        TeomworklocationServiceApi,
        ViewActivityReportApi,
        EmployeeDataUpdateApi,
        SFMassLeaveApi,
        SFClaimCancelRequestApi,
        PayrollHistoryServiceApi,
        EmployeeServiceApi,
        internalStorageProvider,
        SubscriptionServiceApi,
        MakeIdCardApi,
        StorageIdCardApi,
        PersonalApi,
        AddressApi,
        LookupApi,
        EmergencyApi,
        FamilydependentApi,
        EducationApi,
        JobexpApi,
        MedicalApi,
        ContactApi,
        EmployeeCareerApi,
        PersonalEmployeeReportApi,
        AttendanceReportApi,
        SFApprovalSettingApi,
        SunfishAuthenticatorServiceApi,
        PaydayLoanServiceApi,
        BankAccountApi,
        InsuranceDataApi,
        GovernmentTaxApi,
        ListSpvPathApi,
        EmployeeRequestApi,
        TgospfaceencodingApi,
        PaymentServiceApi,
        UsersRatingApi,
        SurveyServiceApi,
        SFLoanRequestApi,
        SFLoanRequestSF6Api,
        YesdokserviceApi,
        { provide: SDKStorage, useClass: StorageBrowser },
        { provide: SocketDriver, useClass: SocketBrowser }
      ]
    };
  }
}
/**
* Have Fun!!!
* - Jon
**/
export * from './models/index';
export * from './services/index';
export * from './lb.config';
export * from './storage/storage.swaps';
export { CookieBrowser } from './storage/cookie.browser';
export { StorageBrowser } from './storage/storage.browser';



// WEBPACK FOOTER //
// ./src/shared/sdk/index.ts